<template>
  <div>
    <div class="h-print mb-2 text-right">
      <el-button
        type="primary"
        size="mini"
        :loading="isDownloading"
        @click="downloadPdf"
      >
        Download PDF
      </el-button>
    </div>
    <print-template
      ref="printTemplate"
      :viewFooter="false"
      :download-only="true"
      download-file-name="delivery-note.pdf"
    >
      <h3 class="mt-3 mb-2">Delivery Note</h3>
      <table class="table table-bordered">
        <tr>
          <th>Description</th>
          <th>Part No.</th>
          <th>ULD ID Code</th>
          <th>Serial</th>
          <th>Status</th>
        </tr>
        <tr v-for="item in list.data" :key="item.id">
          <td>
            <span>{{ getMasterlistDescription(item.masterlist) }}</span>
          </td>
          <td>{{ item.masterlist.part }}</td>
          <td>{{ item.masterlist.uld_id_code }}</td>
          <td>{{ item.masterlist.tso_serial_no }}</td>
          <td>{{ item.status.name }}</td>
        </tr>
      </table>
    </print-template>
  </div>
</template>

<script>
import ULD from "@/models/ULD";
import Masterlist from "@/models/Masterlist";
import PrintTemplate from "@/components/PrintTemplate.vue";
export default {
  name: "DeliveryReport",
  components: { PrintTemplate },
  data: () => ({
    isLoading: false,
    isDownloading: false,
    list: { data: [], paging: {} },
    pager: { limit: 15 },
    descriptions: Masterlist.descriptions()
  }),
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      let params = {
        ...this.pager,
        is_report: 1
      };
      ULD.list(params).then(list => {
        this.list = list;
        this.isLoading = false;
      });
    },
    getMasterlistDescription(masterlist) {
      let check = this.descriptions.find(
        o => o.value == masterlist.description
      );
      if (check) return check.text;
      else return "";
    },
    async downloadPdf() {
      if (!this.$refs.printTemplate) return;
      this.isDownloading = true;
      try {
        await this.$refs.printTemplate.sendPdf();
      } finally {
        this.isDownloading = false;
      }
    }
  },
  mounted() {
    if ("limit" in this.$route.query)
      this.pager.limit = this.$route.query.limit;
    if ("page" in this.$route.query) this.pager.page = this.$route.query.page;
    this.fetch(1);
  }
};
</script>

<style></style>
